import PropTypes from 'prop-types';

import * as Styled from './FeaturedProducts.style';
import { SubscriptionAsset } from './SubscriptionAsset';
import { SubscriptionDetails } from './SubscriptionDetails';
import { SubscriptionMenu } from './SubscriptionMenu';
import { SubscriptionPrice } from './SubscriptionPrice';

import { SERVICE_ACTIVATION_LINK_TEXT, SERVICE_ACTIVATION_PATH_SUFFIXES } from '../constants';

function FeaturedProduct({ product, businessEntityUuid }) {
  const activationSuffix = SERVICE_ACTIVATION_PATH_SUFFIXES[product?.service];
  const activationPath = activationSuffix ? `/dashboard/${businessEntityUuid}${activationSuffix}` : null;
  const activationLinkText = SERVICE_ACTIVATION_LINK_TEXT[product?.service];

  return (
    <Styled.FeaturedProductContainer>
      <SubscriptionAsset service={product?.service} />
      <Styled.FeaturedProductDetails direction="column" alignItems="flex-start" justifyContent="space-between" gap={4}>
        <SubscriptionDetails
          serviceName={product?.displayName || product?.service}
          summary={product?.summary}
          benefits={product?.benefits}
          activationPath={activationPath}
          activationLinkText={activationLinkText}
        />
        <SubscriptionPrice subscription={product} />
      </Styled.FeaturedProductDetails>
      <SubscriptionMenu subscription={product} isIncluded businessEntityUuid={businessEntityUuid} />
    </Styled.FeaturedProductContainer>
  );
}

FeaturedProduct.propTypes = {
  product: PropTypes.shape({
    service: PropTypes.string,
    displayName: PropTypes.string,
    summary: PropTypes.string,
    benefits: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        description: PropTypes.string,
      }),
    ),
  }),
  businessEntityUuid: PropTypes.string,
};

export function FeaturedProducts({ includedProducts, businessEntityUuid }) {
  return (
    <Styled.FeaturedProductsContainer>
      {includedProducts?.map((product) => (
        <FeaturedProduct
          key={product?.orderBillingItemUuid ?? product?.service}
          product={product}
          businessEntityUuid={businessEntityUuid}
        />
      ))}
    </Styled.FeaturedProductsContainer>
  );
}

FeaturedProducts.propTypes = {
  includedProducts: PropTypes.arrayOf(
    PropTypes.shape({
      service: PropTypes.string,
      displayName: PropTypes.string,
    }),
  ),
  businessEntityUuid: PropTypes.string,
};
